import React from 'react';
import { isClientRole } from './Schema';
import UserSummaryRow from './UserSummaryRow';

const getSummaryFields = (portal) => {
  const isClient = isClientRole(portal.role);
  return [
    { key: 'organization', labelKey: 'com.tempedge.msg.label.organization', value: portal.orgName },
    { key: 'role', labelKey: 'com.tempedge.msg.label.role', value: portal.role?.description },
    {
      key: 'lookup',
      labelKey: isClient ? 'com.tempedge.msg.label.client' : 'com.tempedge.msg.label.office',
      value: isClient ? portal.clientName : portal.officeName
    }
  ];
};

const PortalUserSummary = ({ portalUserList = [] }) => (
  <div className="portal-user-summary">
    {portalUserList.map((portal) => (
      <UserSummaryRow key={portal.portalUserConfId} fields={getSummaryFields(portal)} />
    ))}
  </div>
);

export default PortalUserSummary;
